import React, { Component } from 'react'
import MovieCard from './MovieCard';

export default class DetailsBottom extends Component {
    render() {
        const {more} =this.props.details;
        const {dispatch} =this.props;
        return (
            <div className="details-bottom">
                <p className="title">More Like This</p>
                <div className="details-video">
                {more!=undefined&&more.map((movie,key)=>{
                    if(key>=9){
                        return;
                    }else
                    return <MovieCard className="video-card" data={movie} dispatch={dispatch} />
                })} 
                </div>
            </div>
        )
    }
}
